import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type DetachDocumentFromLawyerMessageMutationVariables = Types.Exact<{
  documentId: Types.Scalars['Int']
  messageId: Types.Scalars['Int']
}>

export type DetachDocumentFromLawyerMessageMutation = {
  __typename?: 'Mutation'
  detachDocumentFromLawyerMessage: {
    __typename?: 'Message'
    id: number
    documents?: Array<
      | {
          __typename?: 'CustomerDocument'
          id: number
          fileFormat?: string | null
          fileUrl: string
          name: string
        }
      | {
          __typename?: 'LawyerDocument'
          id: number
          fileFormat?: string | null
          fileUrl: string
          name: string
        }
    > | null
  }
}

export const DetachDocumentFromLawyerMessageDocument = gql`
  mutation DetachDocumentFromLawyerMessage($documentId: Int!, $messageId: Int!) {
    detachDocumentFromLawyerMessage(documentId: $documentId, messageId: $messageId) {
      id
      documents {
        id
        fileFormat
        fileUrl
        name
      }
    }
  }
`
export type DetachDocumentFromLawyerMessageMutationFn = ApolloReactCommon.MutationFunction<
  DetachDocumentFromLawyerMessageMutation,
  DetachDocumentFromLawyerMessageMutationVariables
>
export function useDetachDocumentFromLawyerMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DetachDocumentFromLawyerMessageMutation,
    DetachDocumentFromLawyerMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DetachDocumentFromLawyerMessageMutation,
    DetachDocumentFromLawyerMessageMutationVariables
  >(DetachDocumentFromLawyerMessageDocument, options)
}
export type DetachDocumentFromLawyerMessageMutationHookResult = ReturnType<
  typeof useDetachDocumentFromLawyerMessageMutation
>
export type DetachDocumentFromLawyerMessageMutationResult =
  ApolloReactCommon.MutationResult<DetachDocumentFromLawyerMessageMutation>
export type DetachDocumentFromLawyerMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DetachDocumentFromLawyerMessageMutation,
  DetachDocumentFromLawyerMessageMutationVariables
>
